import { Component, Input } from '@angular/core';

@Component({
  selector: 'kng-cards',
  templateUrl: './kng-cards.component.html',
  styleUrls: []
})
export class KngCardsComponent {

  @Input()
  public size: string = 'md';

  constructor() { }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/layout/kingswell/kng-cards/kng-cards.component.ts